import { AlignType } from 'common/types/styleTypes'
import { usePage, useWebsiteSettings } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { typographySelectorMap } from 'src/publisher/store/website-settings/website-settings-selector'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateTextAlign = ({
  textAlign,
  mobileTextAlign,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const pageGlobalTextAlign = usePage(pageSelectors.getGlobalTextAlign)
  const pageGlobalMobileTextAlign = usePage(
    pageSelectors.getGlobalMobileTextAlign,
  )

  const globalTextAlignOrEmpty =
    typographyType === WebsiteSettingsTypographyTypeEnum.FormField
      ? undefined
      : pageGlobalTextAlign

  const globalMobileTextAlignOrEmpty =
    typographyType === WebsiteSettingsTypographyTypeEnum.FormField
      ? undefined
      : pageGlobalMobileTextAlign

  const typographySelector = typographySelectorMap[typographyType]

  const {
    textAlign: websiteGlobalTextAlign,
    mobileTextAlign: websiteGlobalMobileTextAlign,
  } = useWebsiteSettings(typographySelector) || {}

  const globalTextAlign = websiteGlobalTextAlign || globalTextAlignOrEmpty
  const globalMobileTextAlign =
    websiteGlobalMobileTextAlign || globalMobileTextAlignOrEmpty

  return {
    calculatedTextAlign: getCalculatedProperty({
      desktopProperty: textAlign,
      mobileProperty: mobileTextAlign,
      globalDesktopProperty: globalTextAlign,
      //TODO https://systeme-team.slack.com/archives/C020MV26SBH/p1754505782538659
      globalMobileProperty: textAlign || globalMobileTextAlign,
    }) as { mobile: AlignType; desktop: AlignType },
    globalTextAlign,
    globalMobileTextAlign,
  }
}
